import type { SessionUserDto } from '@tms/shared';
import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api-client';
import { queryKeys } from '../../lib/query-keys';

export const meQueryOptions = queryOptions({
  queryKey: queryKeys.auth.me,
  queryFn: async () => (await api.get<{ user: SessionUserDto }>('/auth/me')).user,
  // An expired session is an expected answer, not a transient failure.
  retry: false,
  staleTime: 5 * 60 * 1000,
});

export const useCurrentUser = () => useQuery(meQueryOptions);

/** Where the GitLab sign-in starts; the round trip ends on the API callback, not in the SPA. */
export const gitlabSignInUrl = (next: string | undefined): string =>
  next
    ? `/api/v1/auth/gitlab/login?${new URLSearchParams({ next }).toString()}`
    : '/api/v1/auth/gitlab/login';

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.post<void>('/auth/logout'),
    onSuccess: () => {
      queryClient.clear();
    },
  });
};
